<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vx-card>
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-12 text-right">
                  <vs-button to="/properties/add">{{
                    $t("featureAdd")
                  }}</vs-button>
                </div>

                <div class="col-md-12 mt-2">
                  <vs-input
                    size="small"
                    style="float: right; height: 15px"
                    @input="isTyping = true"
                    v-model="searchInput"
                    :label-placeholder="$t('search')"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <vs-table
                    max-items="20"
                    stripe
                    :data="$store.state.propertiesData"
                    class="w-full ml-3 mr-3"
                    maxHeight="1000px"
                  >
                    <template slot="header">
                      <h3>{{ $t("features") }}</h3>
                    </template>
                    <template slot="thead">
                      <vs-th class="colors width">{{ $t("controller") }}</vs-th>

                      <vs-th class="colors" sort-key="typeEntityId">{{
                        $t("type")
                      }}</vs-th>
                      <vs-th class="colors" sort-key="propertiesName">{{
                        $t("featureName")
                      }}</vs-th>
                      <vs-th class="colors" sort-key="categoryName">{{
                        $t("categoryName")
                      }}</vs-th>

                      <vs-th class="colors" sort-key="createDate">{{
                        $t("createdDate")
                      }}</vs-th>
                    </template>
                    <template slot-scope="{ data }">
                      <vs-tr
                        class="table-line"
                        :key="indextr"
                        v-for="(item, indextr) in data"
                      >
                        <vs-td class="text-center width" :data="item.id">
                          <ActionButton
                            :id="item.id"
                            :typeEntityId="item.typeEntityId"
                            :propertyName="item.propertyName"
                            :userId="item.userId"
                            @refresh="selectPage"
                          ></ActionButton>
                        </vs-td>

                        <vs-td :data="item.entityName">{{
                          item.entityName
                        }}</vs-td>
                        <vs-td :data="item.propertyName">{{
                          item.propertyName
                        }}</vs-td>
                        <vs-td :data="item.categoryName">{{
                          item.categoryName
                        }}</vs-td>
                        <vs-td :data="item.createDate">{{
                          item.createDate
                        }}</vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <div class="col-md-12 mt-5">
                    <vs-pagination
                      v-show="$store.state.propertiesData.length != 0"
                      :total="totalPage"
                      :max="9"
                      v-model="currentPage"
                      @change="selectPage"
                    ></vs-pagination>
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import ActionButton from "./Buttons/ActionsButton";
import _ from "lodash";
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";

export default {
  components: {
    ActionButton,
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      searchInput: "",
      isTyping: false,
    };
  },
  watch: {
    searchInput: _.debounce(function () {
      this.isTyping = false;
    }, 500),
    isTyping: function (value) {
      if (!value) {
        this.searchData(this.searchInput);
      }
    },
  },
  methods: {
    selectPage(page) {
      if (page == "") page = 1;
      this.currentPage = 1;
      if (this.$store.state.role == "User") {
        let path = "/properties/getByUserId";
        http
          .post(path, {
            RequestPage: page,
            UserId: parseInt(this.$store.state.userId),
          })
          .then((response) => {
            const formatTr = new Intl.DateTimeFormat("tr", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });
            this.totalPage = response.totalPage;
            this.page = response.currentPage;
            var values = response.data;
            for (let index = 0; index < values.length; index++) {
              if (values[index].active == true) values[index].active = "Aktif";
              if (values[index].active == false) values[index].active = "Pasif";
              values[index].createDate = formatTr.format(
                new Date(values[index].createDate)
              );
              if (values[index].entityName === "number") {
                values[index].entityName = this.$t("number");
              }
              if (values[index].entityName === "text") {
                values[index].entityName = this.$t("text");
              }
            }
            this.$store.state.propertiesData = values;
          });
      }
      if (this.$store.state.role == "Admin") {
        let path = "/properties/GetListByPaging";
        http.post(path, { RequestPage: page }).then((response) => {
          const formatTr = new Intl.DateTimeFormat("tr", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          });
          this.totalPage = response.totalPage;
          this.page = response.currentPage;
          var values = response.data;
          for (let index = 0; index < values.length; index++) {
            if (values[index].active == true) values[index].active = "Aktif";
            if (values[index].active == false) values[index].active = "Pasif";
            values[index].createDate = formatTr.format(
              new Date(values[index].createDate)
            );
            if (values[index].entityName === "number") {
              values[index].entityName = this.$t("number");
            }
            if (values[index].entityName === "text") {
              values[index].entityName = this.$t("text");
            }
          }
          this.$store.state.propertiesData = values;
        });
      }
    },
    searchData(searchInput) {
      if (this.$store.state.role == "User") {
        let path = "/properties/getByUserId";
        http
          .post(path, {
            RequestPage: 1,
            UserId: parseInt(this.$store.state.userId),
            SearchText: searchInput,
          })
          .then((response) => {
            if (response.data.length == 0) {
              return notify.warning(this.$t("nomatch"));
            }
            this.currentPage = response.currentPage;
            this.totalPage = response.totalPage;
            const formatTr = new Intl.DateTimeFormat("tr", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });
            var values = response.data;
            for (let index = 0; index < values.length; index++) {
              if (values[index].active == true) values[index].active = "Aktif";
              if (values[index].active == false) values[index].active = "Pasif";
              values[index].createDate = formatTr.format(
                new Date(values[index].createDate)
              );
            }
            this.$store.state.propertiesData = values;
          });
      }
      if (this.$store.state.role == "Admin") {
        let path = "/properties/GetListByPaging";
        http
          .post(path, { RequestPage: 1, SearchText: searchInput })
          .then((response) => {
            if (response.data.length == 0) {
              return notify.warning(this.$t("nomatch"));
            }
            this.currentPage = response.currentPage;
            this.totalPage = response.totalPage;
            const formatTr = new Intl.DateTimeFormat("tr", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });
            var values = response.data;
            for (let index = 0; index < values.length; index++) {
              if (values[index].active == true) values[index].active = "Aktif";
              if (values[index].active == false) values[index].active = "Pasif";
              values[index].createDate = formatTr.format(
                new Date(values[index].createDate)
              );
            }
            this.$store.state.propertiesData = values;
          });
      }
    },
  },
  created() {},
};
</script>

<style scoped>
.colors {
  background-color: rgb(218, 216, 216) !important;
}

.width {
  width: 110px !important;
}
</style>